import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchRemoveDeviceFromOrganisation } from './dispatch-optimistic-patch';
import { RemoveDeviceFromOrganisationQueryArg } from '../types/query-arg';

export const handleResultRemoveDeviceFromOrganisation: QueryHandler<
  RemoveDeviceFromOrganisationQueryArg,
  void
> = async (queryArg, { queryFulfilled, ...api }) => {
  const { patch } = dispatchOptimisticPatchRemoveDeviceFromOrganisation(
    queryArg,
    api,
  );

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
